import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { ThemeContext } from 'lib/util/themes/currentThemeContext';
import { themeObject } from 'lib';

interface PageHeaderProps {
    subTitle?: string;
    tagline?: string;
    title: string;
}

const styles = {
    title: {
        fontFamily: 'Raleway',
        fontSize: '28px',
        fontWeight: 600,
        lineHeight: '33px',
        letterSpacing: '0px',
        textAlign: 'left',
        color: themeObject.palette.primary[800],
        mb: 0,
        fontVariantNumeric: 'lining-nums',
        textWrap: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    boxContainer: {
        width: '100%',
    },
};
export const PageHeader = ({
    title,
    subTitle,
    tagline,
}: PageHeaderProps): React.JSX.Element => {
    const { currentTheme } = useContext(ThemeContext);

    const capitalizeFirstLetter = (text: string): string => {
        return text.charAt(0).toUpperCase() + text.slice(1);
    };

    return (
        <Box sx={styles.boxContainer}>
            <Typography
                variant='h4'
                gutterBottom
                color='primary'
                sx={{ ...styles.title, ...currentTheme?.titleCopy }}
            >
                {capitalizeFirstLetter(title)}
            </Typography>
            <Typography variant='h5' color='secondary'>
                {subTitle}
            </Typography>
            <Typography variant='body1'>{tagline}</Typography>
        </Box>
    );
};
